








import { watch, computed } from '@vue/composition-api';
export default {
  props: {
    show: Boolean,
    applyWord: {
      type: String,
      default: '',
    },
  },
  model: {
    prop: 'show',
    event: 'change',
  },

  setup(props, { emit }) {
    const handleClose = () => {
      emit('change', false);
    };

    const computedShow = computed({
      get() {
        return props.show;
      },
      set() {
        emit('change', false);
      },
    });

    watch(
      () => props.show,
      (val) => {
        if (val) {
          setTimeout(() => {
            handleClose();
          }, 1500);
        }
      },
    );

    return {
      computedShow,
    };
  },
};
